import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultiSavingsPlan, SavingsPlanFacade } from '@zero/saving-plans/domain';
import { AssetSearchComponent } from '@zero/shared/ui-web-components';
import { Asset } from '@zero/shared/util-models';
import { IgnoreThousandSeparatorPipe } from '../../../pipes/ignore-thousand-separator.pipe';
import { SavingsPlanSearchComponent } from '../../savings-plan-search/savings-plan-search.component';

@Component({
  selector: 'saving-plans-create-list',
  imports: [AssetSearchComponent, TranslocoPipe, AsyncPipe, FormsModule, IgnoreThousandSeparatorPipe],
  templateUrl: './savings-plan-create-list.component.html',
  styleUrl: './savings-plan-create-list.component.scss',
})
export class SavingsPlanCreateListComponent {
  @Input() public assets: Asset[] = [];

  public readonly facade = inject(SavingsPlanFacade);
  readonly #modal = inject(NgbModal);
  readonly #destroyRef = inject(DestroyRef);

  public openFurtherSavingsPlanModal() {
    const ref = this.#modal.open(SavingsPlanSearchComponent);
    ref.componentInstance.currentAssets = this.assets;
    ref.componentInstance.assetPicked
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((asset: Asset) => this.facade.addAssetToForm(asset));
  }

  public handleChangeAmount = (savingsPlan: MultiSavingsPlan, ev: Event) => {
    const value = ev.target['value'];
    const amount = value ? Number(value.replace(',', '.')) : null;
    !isNaN(amount) && this.facade.updateAmount(savingsPlan, amount);
  };
}
